module.exports = __webpack_public_path__ + "img/welcome-image.07dd238c.png";